import i18n from '@plugins/i18n';

import { Collection, Shortlist } from '@/models';

export class ShortlistCollection extends Collection {
    static type = 'ShortlistCollection';
    static endpoint = Shortlist.api.index;
    static model = Shortlist;

    get headers() {
        const auth = this.Auth();

        const isFundManagerOrProvider = auth.is_fund_manager || auth.is_provider;

        return [
            this.createHeader('name', i18n.t('name'), {
                width: '18rem',
                minWidth: '18rem',
                to: data =>
                    isFundManagerOrProvider ? null : { name: 'Shortlist', query: { shortlist_id: data.item.id } },
                filterable: {
                    operators: this.getOperators(['contains', 'starts_with', 'ends_with'])
                },
                mock: '{{person.firstName}} {{location.city}}'
            }),
            this.createHeader('investor_id', i18n.tc('investor'), {
                width: '14rem',
                filterable: {
                    operators: this.getOperators(['eq']),
                    component: () => import('@/components/fields/Investor.vue')
                },
                path: 'investor.name',
                mock: '{{person.fullName}}'
            }),
            this.createHeader('total_offers', i18n.t('total_offers'), {
                format: 'number',
                path: 'entry_quantity',
                transform: data => data.item.entry_quantity,
                width: '10rem'
            }),
            this.createHeader('total_value', i18n.t('total_value'), {
                format: 'money',
                path: 'total_cleared_funds_required',
                width: '12rem'
            }),
            this.createHeader('last_edited_date', i18n.t('last_edited_date'), {
                format: 'datetime',
                width: '14rem',
                align: 'right'
            }),
            this.createHeader('control', '', {
                format: 'control',
                width: '7rem',
                persistent: true
            })
        ];
    }
}

export default ShortlistCollection;
